import { render, staticRenderFns } from "./system-info-modal.vue?vue&type=template&id=548dfc3f&scoped=true"
import script from "./system-info-modal.vue?vue&type=script&lang=js"
export * from "./system-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548dfc3f",
  null
  
)

export default component.exports